import { createElement, Component } from 'react';
import { observer } from 'mobx-react';
import { flowRight } from 'lodash';
import { store } from '../store';
import withStyles, { WithStyles } from 'react-jss';

const styles = {
    root: {
        display: 'block',
        flexWrap: 'wrap',
    },
    item: {
        flexBasis: '50%',
    },
};

interface IProps extends WithStyles<typeof styles> {
    type: string;
}

class ComponentsList extends Component<IProps, any> {
    render() {
        let { classes, type } = this.props;

        return (
            <div className={classes.root}>
                {store.components
                    .filter((c) => c.type === type)
                    .map((c) => {
                        return (
                            <div className={classes.item} key={c.name}>
                                <c.shelfComponent />
                            </div>
                        );
                    })}
            </div>
        );
    }
}

export default flowRight([withStyles(styles), observer])(ComponentsList);
